/* eslint-disable max-len */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { List } from 'immutable'
import _partial from 'lodash/partial'
import _get from 'lodash/get'
import NavigationPrimary from 'components/NavigationPrimary'
import Hamburger from 'components/Hamburger'
import Button, { TYPES } from 'components/Button'
import ButtonSignUp, { BUTTON_SIGN_UP_TYPE_BUTTON } from 'components/ButtonSignUp'
import HeaderV2 from 'components/HeaderV2'
import LanguageSelectGlobe from 'components/LanguageSelectGlobe'
import AlertBarLoader from 'components/AlertBarLoader'
import GaiaLogo, { TYPE_TEAL } from 'components/GaiaLogo'
import { getBoundActions } from 'actions'
import { connect as connectRedux } from 'react-redux'
import { TYPE_LOGIN, TYPE_DAYTONA_WA_10 } from 'services/dialog'
import { deactivateSubject } from 'services/testarossa'
import { get as getConfig } from 'config'
import {
  URL_CART_BILLING, URL_CART_BILLING_PAYMENT, URL_CART_CONFIRMATION,
} from 'services/url/constants'
import { DaytonaCampaign } from 'components/Daytona'
import {
  ROLE_ID_SITE_ADMIN, ROLE_ID_DEVELOPER, ROLE_ID_QA, ROLE_ID_EDITOR,
} from 'services/auth-access'
import { FEATURE_NAME_SETTINGS_TOOLTIP } from 'services/feature-tracking/constants'
import { isMemberCustomizationToolTipEligible } from 'services/feature-tracking'
import {
  NAVIGATION_EVENT_LABELS,
  getNavClickedGa4Event,
} from 'services/event-tracking'
import { getAuthIsLoggedIn } from 'services/auth'
import { isMemberHome } from 'services/url'

const config = getConfig()
const EMPTY_LIST = List()

function renderLoginButton (
  auth,
  setOverlayDialogVisible,
  dialogName,
  text,
  userLanguage,
) {
  if (auth.get('jwt')) {
    return null
  }

  const baseClassName = 'header__action-button'
  const buttonClassName = [
    'button--x-small',
    'button--secondary',
    'button--login',
    baseClassName,
    `${baseClassName}--left`,
  ].concat(userLanguage ? `${baseClassName}--${userLanguage}` : [])
  return (
    <Button
      type={TYPES.SECONDARY}
      className={buttonClassName.join(' ')}
      onClick={_partial(
        onClickLoginButton,
        _partial.placeholder,
        setOverlayDialogVisible,
        dialogName,
      )}
    >
      {text}
    </Button>
  )
}

function closeModal () {
  deactivateSubject({ campaign: 'WA-10' })
}

function onClickLoginButton (e, setOverlayDialogVisible, dialogName) {
  e.stopPropagation()
  e.preventDefault()
  setOverlayDialogVisible(dialogName)
}

function renderButtonSignUp (auth, text, userLanguage) {
  if (auth.get('jwt')) {
    return null
  }
  const baseClassName = 'header__action-button'
  const buttonClassName = [
    'button--last',
    'button--x-small',
    'button--primary',
    'header__button--signup',
    baseClassName,
  ].concat(userLanguage ? `${baseClassName}--${userLanguage}` : [])
  return (
    <ButtonSignUp
      text={text}
      buttonClass={buttonClassName}
      type={BUTTON_SIGN_UP_TYPE_BUTTON}
      scrollToTop
    />
  )
}

function shouldRenderLanguageSelectGlobe (auth) {
  const allowedRoles = [ROLE_ID_QA, ROLE_ID_SITE_ADMIN, ROLE_ID_DEVELOPER, ROLE_ID_EDITOR]
  const roleIds = auth.get('roleIds', List())
  const isUnauthenticated = !auth.get('jwt')
  const roleIsAllowed = allowedRoles.reduce((acc, nextRole) => {
    if (acc === true || roleIds.includes(nextRole)) {
      return true
    }
    return false
  }, false)

  if (isUnauthenticated || roleIsAllowed) {
    return true
  }
  return false
}

function renderLanguageSelectGlobe (props, setNavigationClickEvent) {
  const { auth, location } = props

  if (
    location.pathname === URL_CART_BILLING
    || location.pathname === URL_CART_BILLING_PAYMENT
    || location.pathname === URL_CART_CONFIRMATION
    || !shouldRenderLanguageSelectGlobe(auth)
  ) {
    return null
  }

  return (
    <LanguageSelectGlobe setNavigationClickEvent={setNavigationClickEvent} />
  )
}

function renderNavigation () {
  return (
    <NavigationPrimary />
  )
}

class Header extends Component {
  //
  constructor (props) {
    super(props)
    this.state = {
      tooltipHidden: false,
    }

    const showLogin = _get(props, ['location', 'query', 'login'])
    if (showLogin) {
      props.setOverlayDialogVisible(TYPE_LOGIN)
    }
    this.toolTipEligible = isMemberCustomizationToolTipEligible(
      props.featureTracking,
      props.userStore,
      FEATURE_NAME_SETTINGS_TOOLTIP,
    )
  }

  componentDidUpdate (prevProps) {
    const { props } = this
    const { path, resetHeaderNav } = props
    const { path: prevPath } = prevProps
    if (path !== prevPath) {
      resetHeaderNav()
    }
  }

  onClickHamburger = (e) => {
    e.stopPropagation()
    const { props } = this
    const {
      toggleNavigationOverlayVisible,
      showInviteFriendPopup,
      userReferrals,
      setDefaultGa4Event,
    } = props
    const shouldCloseInviteFriendPopup = userReferrals.getIn(['showInviteFriendPopup'])
    toggleNavigationOverlayVisible()
    if (shouldCloseInviteFriendPopup) {
      showInviteFriendPopup(false)
    }

    setDefaultGa4Event(getNavClickedGa4Event('v2').mergeDeep({
      nav_element: 'hamburger',
    }))
  }

  setNavigationClickEvent = (eventLabel, eventElement) => {
    if (!eventLabel) return
    const { props } = this
    const {
      setDefaultGa4Event,
    } = props
    // GA4 event
    setDefaultGa4Event(getNavClickedGa4Event('v2').mergeDeep({
      nav_element: eventElement,
    }))
  }

  renderDebugUsername = () => {
    const { props } = this
    const { auth } = props
    const showDebugUsername = _get(config, ['debug', 'showUsername']) > 0
    if (showDebugUsername) {
      const username = auth.get('username', '<anonymous>')
      return <div className="header__debug-username">{username}</div>
    }
    return null
  }

  render () {
    const { props, setNavigationClickEvent } = this
    const {
      setOverlayDialogVisible,
      staticTextHeader,
      overlayVisible,
      userLanguage,
      dismissModal,
      isGiftCompatible,
      hideUserMenu,
      hideNavBar,
      hideLogin,
      location,
      history,
      menu,
      auth,
      resolver,
    } = props

    const language = userLanguage.get(0, _get(config, ['appLang']))
    const isLoggedIn = getAuthIsLoggedIn(auth)
    const primaryItems = menu.getIn(['data', 'nav'], List())
    const isMemberHomePage = isMemberHome(resolver.get('path'), isLoggedIn)

    return isLoggedIn
      ? <HeaderV2
        history={history}
        location={location}
        isGiftCompatible={isGiftCompatible}
        hideLogin={hideLogin}
        hideNavBar={hideNavBar}
        hideUserMenu={hideUserMenu}
        navItems={primaryItems.filter((i) => i.get('auth', false) === true)}
        navVersion={'v2'}
        darkMode={isMemberHomePage}
      />
      : <header className="header" role="banner">
        <AlertBarLoader history={history} location={location} />
        <div className="header__top">
          {hideNavBar ? null : (
            <Hamburger
              navigationOverlayVisible={overlayVisible}
              className="header__hamburger header__hamburger--nav"
              onClick={this.onClickHamburger}
            />
          )}
          <div className="header__branding">
            <GaiaLogo
              onClick={() => { setNavigationClickEvent(NAVIGATION_EVENT_LABELS.LOGO, 'logo') }}
              type={TYPE_TEAL}
              className={['header__logo']}
              isHref
            />
            {this.renderDebugUsername()}
          </div>
          <div className="header__actions">
            {/* If a user is checking out, the language select globe does not show */}
            {renderLanguageSelectGlobe(props, setNavigationClickEvent)}
            {/* If a user is logged out, show login and signup buttons */}
            {hideLogin
              ? null
              : renderLoginButton(
                auth,
                setOverlayDialogVisible,
                TYPE_LOGIN,
                staticTextHeader.getIn(['data', 'login']),
                language,
                location,
              )}
            {hideNavBar
              ? null
              : renderButtonSignUp(
                auth,
                staticTextHeader.getIn(['data', 'signUp']),
                language,
              )
            }
          </div>
        </div>
        {hideNavBar ? null : renderNavigation(props)}
        <DaytonaCampaign id="WA-10">
          {(c, v) => {
            props.renderModal(TYPE_DAYTONA_WA_10, {
              onDismiss: () => closeModal(),
              className: 'wa-10',
              close: dismissModal,
              title: _get(v, ['data', 'title', 'value'], ''),
              c,
              v,
            })
          }}
        </DaytonaCampaign>
      </header>
  }
}

Header.propTypes = {
  isGiftCompatible: PropTypes.string,
  hideUserMenu: PropTypes.bool.isRequired,
  hideNavBar: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  hideLogin: PropTypes.bool.isRequired,
  history: PropTypes.object,
}

export default connectRedux(
  (state) => ({
    auth: state.auth,
    path: state.resolver.get('path'),
    overlayVisible: state.header.get('navigationOverlayVisible'),
    staticTextHeader: state.staticText.getIn(['data', 'header']),
    userLanguage: state.user.getIn(['data', 'language'], EMPTY_LIST),
    userReferrals: state.userReferrals,
    userStore: state.user,
    menu: state.menu,
    featureTracking: state.featureTracking,
    resolver: state.resolver,
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      renderModal: actions.dialog.renderModal,
      dismissModal: actions.dialog.dismissModal,
      resetHeaderNav: actions.header.resetHeaderNav,
      toggleNavigationOverlayVisible: actions.header.toggleNavigationOverlayVisible,
      setNavigationOverlayVisible: actions.header.setNavigationOverlayVisible,
      setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
      showInviteFriendPopup: actions.userReferrals.showInviteFriendPopup,
      setDefaultGa4Event: actions.eventTracking.setDefaultGa4Event,
    }
  },
)(Header)
